import { fabric } from "fabric";
import DEFINE from "../define";
import ToolBase from "../basic";

import EventBus from "../../event_bus";

import VerticalTextbox from "../../../../lib/VerticalTextbox";
import * as iTextBorder from "../../../../lib/iTextBorder";
import { store } from '../../../store';
import { windowContentScaleX, windowContentScaleY } from "../../common/content_scale";


export default class textBox extends ToolBase {

    static texSize = 24;

    name = DEFINE.TOOLS.TEXT_BOX;

    point = {
        x: 0,
        y: 0
    }

    currentTextBoxAttribute = "";
    currentTextBox = null;

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        console.log(object);

        let self = this;

        const setTextBoxBarFunc = this.setTextBoxBar.bind(this);
        const textBoxBarCloseFunc = this.textBoxBarClose.bind(this);

        object.set({
            hasControls: false,
            editingEntered: { key: "editing:entered", run: setTextBoxBarFunc },
            editingExited: { key: "editing:exited", run: textBoxBarCloseFunc },
            textboxBorderColor: object.data.textboxBorderColor,
        });

        if (object.data.type == DEFINE.TAG.TEXT_BOX_HORIZONTAL) {
            object.on(object.editingEntered.key, object.editingEntered.run);
            object.on(object.editingExited.key, object.editingExited.run);
            //self.parent.addHistory();
        }
        else if (object.data.type == DEFINE.TAG.TEXT_BOX_VERTICAL) {

            object.on(("changed"), function () { object.set("width", 1); });
            object.on(object.editingEntered.key, object.editingEntered.run);
            object.on(object.editingExited.key, object.editingExited.run);
            //self.parent.addHistory();
        }
        self.canvas.renderAll();
    }

    mouseDown(o) {
        console.log("textbox:mousedown", o)
        const eTouch = o.e.touches;
        let pointer = this.canvas.getPointer(o.e)
        this.parent.proxy.changeTool(null);

        let self = this;

        this.point = {
            x: pointer.x,
            y: pointer.y,
            clientX: (eTouch ? eTouch[0].clientX : null) || o.e.clientX || o.pointer.x,
            clientY: (eTouch ? eTouch[0].clientY : null) || o.e.clientY || o.pointer.y
        }

        this.selectDirection(self, this.point);
    }

    selectDirection(self, point) {
        let clientX = point.clientX;
        let clientY = point.clientY;


        EventBus.getInstance().emit("sendTextBoxSelectDirection", {
            point: { x: (clientX - store.contentSize.x) / store.contentScale, y: (clientY - store.contentSize.y) / store.contentScale},
            optionsClick: selectDirectionBtn,
        });

        function selectDirectionBtn(direction) {
            self.createTextBox(self, point, direction);
            self.parent.addHistory();
        }
    }

    createTextBox(self, point, direction) {
        let newX = point.x;
        let newY = point.y;

        let clientX = point.clientX;
        let clientY = point.clientY;

        const TEXT = "文字方塊:請輸入你要的內容";

        const setTextBoxBarFunc = this.setTextBoxBar.bind(this);
        const textBoxBarCloseFunc = this.textBoxBarClose.bind(this);

        let style = {
            toolType: self.name,
            fill: "#292929",
            editable: true,
            fontSize: textBox.texSize,
            fontWeight: "normal",
            underline: false,
            backgroundColor: "transparent",
            fontFamily: "Microsoft JhengHei-Light",
            left: newX,
            top: newY,
            clientX: clientX,
            clientY: clientY,
            lineHeight: 1,
            linethrough: false,
            overline: false,
            hasControls: false,
            textboxBorderColor: "transparent",
            editingEntered: { key: "editing:entered", run: setTextBoxBarFunc },
            editingExited: { key: "editing:exited", run: textBoxBarCloseFunc }
        };
        console.log("direction::", direction);
        if (direction == DEFINE.TEXT_DIRECTION.VERTICAL) {
            let CJK_TEXT = new VerticalTextbox(TEXT, Object.assign(style, {
                tag: DEFINE.TAG.TEXT_BOX + new Date().getTime(),
                data: {
                    type: DEFINE.TAG.TEXT_BOX_VERTICAL,
                    textboxBorderColor: "transparent"
                },
            }));
            CJK_TEXT.on(CJK_TEXT.editingEntered.key, CJK_TEXT.editingEntered.run);
            CJK_TEXT.on(CJK_TEXT.editingExited.key, CJK_TEXT.editingExited.run);
            self.canvas.add(CJK_TEXT);
            console.log(CJK_TEXT);

        }
        else if (direction == DEFINE.TEXT_DIRECTION.HORIZONTAL) {
            let TEXT_BOX = new fabric.IText(TEXT, Object.assign(style, {
                tag: DEFINE.TAG.TEXT_BOX + new Date().getTime(),
                data: {
                    type: DEFINE.TAG.TEXT_BOX_HORIZONTAL,
                    textboxBorderColor: "transparent"
                },
            }));
            TEXT_BOX.on(TEXT_BOX.editingEntered.key, TEXT_BOX.editingEntered.run);
            TEXT_BOX.on(TEXT_BOX.editingExited.key, TEXT_BOX.editingExited.run);
            self.canvas.add(TEXT_BOX);
            console.log(TEXT_BOX);
        }
    }

    textBoxBarClose() {
        EventBus.getInstance().emit("sendTextBoxBar", {
            boxBarShow: false
        });
        let activeTxt = this.canvas.getActiveObject();
        if(this.currentTextBox) {
            const editedTextBoxAttribute = JSON.stringify(this.currentTextBox.toJSON());
    
            if (this.currentTextBoxAttribute != editedTextBoxAttribute) {
                this.parent.addHistory();
            } 
        }
    }

    setTextBoxBar() {
        const self = this;
        let activeTxt = this.canvas.getActiveObject();
        this.currentTextBox = activeTxt;

        const oCoords = this.currentTextBox.oCoords;

        this.currentTextBoxAttribute = JSON.stringify(activeTxt.toJSON());

        EventBus.getInstance().emit("sendTextBoxBar", {
            point: { x: oCoords.tl.x, y: oCoords.tl.y },
            boxBarShow: true,
            arg: {
                textSize: activeTxt.fontSize,
            },
            updateTextSize: fontSize,
            updateTextColor: fontColor,
            updateBold: fontBold,
            updateItalic: fontItalic,
            updateUnderline: fontUnderline,
            updateTextBoxColor: textBoxColor,
            updateTextBoxBorderColor: textBoxBorderColor,
            delTextBox: delTextBox
        });

        function fontSize(newSize) {
            // 当前选中的元素
            console.log(newSize);

            let activeTxt = self.canvas.getActiveObject()

            if (activeTxt == null) return;
            if (activeTxt.isEditing) {
                textBox.texSize = newSize;
                activeTxt.setSelectionStyles({ fontSize: newSize }); // 设置选中文字的样式
                self.canvas.renderAll(); // 重新渲染画布
                // self.parent.addHistory();
            }
        }

        function fontColor(newColor) {
            let activeTxt = self.canvas.getActiveObject()
            if (activeTxt == null) return;
            if (activeTxt.isEditing) {
                activeTxt.setSelectionStyles({ fill: newColor }); // 设置选中文字的样式
                self.canvas.renderAll(); // 重新渲染画布
                // self.parent.addHistory();
            }
        }

        function fontBold() {
            // 当前选中的元素
            let activeTxt = self.canvas.getActiveObject();

            if (activeTxt == null) return;
            if (activeTxt.isEditing) {

                if (activeTxt.getStyleAtPosition(activeTxt.selectionStart, activeTxt.selectionEnd)["fontWeight"] != "bold") {
                    activeTxt.setSelectionStyles({ "fontWeight": "bold" }) // 设置选中文字的样式
                }
                else {
                    activeTxt.setSelectionStyles({ "fontWeight": "normal" }) // 设置选中文字的样式
                }
                canvas.renderAll() // 重新渲染画布
                // self.parent.addHistory();
            }
        }

        function fontBold() {
            // 当前选中的元素
            let activeTxt = self.canvas.getActiveObject()

            if (activeTxt == null) return;
            if (activeTxt.isEditing) {

                if (activeTxt.getStyleAtPosition(activeTxt.selectionStart, activeTxt.selectionEnd)["fontWeight"] != "bold") {
                    activeTxt.setSelectionStyles({ "fontWeight": "bold" }) // 设置选中文字的样式
                }
                else {
                    activeTxt.setSelectionStyles({ "fontWeight": "normal" }) // 设置选中文字的样式
                }
                self.canvas.renderAll() // 重新渲染画布
                // self.parent.addHistory();
            }
        }

        function fontItalic() {
            // 当前选中的元素
            let activeTxt = self.canvas.getActiveObject()
            if (activeTxt == null) return;
            if (activeTxt.isEditing) {
                if (activeTxt.getStyleAtPosition(activeTxt.selectionStart, activeTxt.selectionEnd)["fontStyle"] != "italic") {
                    activeTxt.setSelectionStyles({ "fontStyle": "italic" }) // 设置选中文字的样式
                }
                else {
                    activeTxt.setSelectionStyles({ "fontStyle": "normal" }) // 设置选中文字的样式
                }
                self.canvas.renderAll() // 重新渲染画布
                // self.parent.addHistory();
            }
        }

        function fontUnderline() {
            // 当前选中的元素
            let activeTxt = self.canvas.getActiveObject()

            if (activeTxt == null) return;
            if (activeTxt.isEditing) {
                if (activeTxt.type === "i-text") {
                    if (activeTxt.getStyleAtPosition(activeTxt.selectionStart, activeTxt.selectionEnd)["underline"] != true) {
                        activeTxt.setSelectionStyles({ "underline": true }) // 设置选中文字的样式
                    }
                    else {
                        activeTxt.setSelectionStyles({ "underline": false }) // 设置选中文字的样式
                    }
                } else if (activeTxt.type === "vertical-textbox") {
                    if (activeTxt.getStyleAtPosition(activeTxt.selectionStart, activeTxt.selectionEnd)["overline"] != true) {
                        activeTxt.setSelectionStyles({ "overline": true }) // 设置选中文字的样式
                    }
                    else {
                        activeTxt.setSelectionStyles({ "overline": false }) // 设置选中文字的样式
                    }
                }
                self.canvas.renderAll() // 重新渲染画布
                // self.parent.addHistory();
            }
        }

        function textBoxColor(newColor) {
            // 当前选中的元素
            let activeTxt = self.canvas.getActiveObject()
            if (activeTxt == null) return;

            activeTxt.set({
                backgroundColor: newColor
            })
            self.canvas.renderAll();
            // self.parent.addHistory();
        }

        function textBoxBorderColor(newColor) {
            // 当前选中的元素
            let activeTxt = self.canvas.getActiveObject()
            if (activeTxt == null) return;

            activeTxt.statefullCache = true;
            activeTxt.set({
                showTextBoxBorder: true,
                textboxBorderColor: newColor,
                width: activeTxt.width + 1,
            });

            activeTxt.data.textboxBorderColor = newColor;

            activeTxt.set({
                width: activeTxt.width - 1
            });

            self.canvas.requestRenderAll(true);
            // self.parent.addHistory();
        }

        function delTextBox() {
            // 当前选中的元素
            let activeTxt = self.canvas.getActiveObject()
            if (activeTxt == null) return;
            activeTxt.off(activeTxt.editingEntered.key, activeTxt.editingEntered.run);
            activeTxt.off(activeTxt.editingExited.key, activeTxt.editingExited.run);
            self.canvas.remove(activeTxt);
            self.canvas.requestRenderAll(true);
            self.parent.addHistory();
        }
    }
}